import React from 'react';
import './Services.css';

const Services = () => {
  const serviceCategories = [
    {
      id: 'company-law',
      title: 'Company Law Management Services',
      services: [
        'Company Incorporation',
        'Corporate Compliance',
        'Board Meetings & AGMs',
        'Share Capital Management',
        'Corporate Governance'
      ]
    },
    {
      id: 'sebi',
      title: 'SEBI and Listing',
      services: [
        'Listing Compliance',
        'Disclosure Requirements',
        'Corporate Governance for Listed Entities',
        'SEBI Regulations Advisory'
      ]
    },
    {
      id: 'forex',
      title: 'Foreign Exchange Management',
      services: [
        'FEMA Compliance',
        'Foreign Investment Advisory',
        'ECB & FDI Advisory',
        'Export-Import Compliance'
      ]
    },
    {
      id: 'mutual-funds',
      title: 'Services Provided to Mutual Funds',
      services: [
        'Compliance Services',
        'Regulatory Filings',
        'Advisory Services'
      ]
    },
    {
      id: 'applications',
      title: 'Applications and Approvals',
      services: [
        'Regulatory Approvals',
        'License Applications',
        'Compliance Certifications'
      ]
    },
    {
      id: 'restructuring',
      title: 'Corporate Restructuring Services',
      services: [
        'Mergers & Acquisitions',
        'Demergers',
        'Business Reorganization',
        'Corporate Restructuring Advisory'
      ]
    },
    {
      id: 'legal',
      title: 'Legal Services',
      services: [
        'Corporate Legal Advisory',
        'Contract Drafting & Review',
        'Litigation Support',
        'Legal Due Diligence'
      ]
    },
    {
      id: 'accounting',
      title: 'Accounting Services',
      services: [
        'Bookkeeping',
        'Financial Reporting',
        'Tax Planning & Compliance',
        'Accounting Advisory'
      ]
    },
    {
      id: 'cfo',
      title: 'Virtual CFO',
      services: [
        'Financial Strategy',
        'Budget Planning',
        'Financial Analysis',
        'Cash Flow Management'
      ]
    },
    {
      id: 'csr',
      title: 'CSR Advisory',
      services: [
        'CSR Strategy Development',
        'CSR Implementation',
        'CSR Compliance',
        'Impact Assessment'
      ]
    }
  ];

  return (
    <div className="services-page">
      <section className="services-hero">
        <div className="container">
          <h1>Our Services</h1>
          <p>Comprehensive legal, secretarial, and advisory services for your business</p>
        </div>
      </section>

      <section className="section services-content">
        <div className="container">
          <div className="services-intro">
            <p className="section-subtitle">
              We offer a wide range of corporate, legal, and secretarial services to help 
              businesses navigate complex regulatory landscapes and achieve their goals.
            </p>
          </div>

          <div className="services-list">
            {serviceCategories.map((category) => (
              <div key={category.id} id={category.id} className="service-category">
                <h2 className="category-title">{category.title}</h2>
                <ul className="service-items">
                  {category.services.map((service, index) => (
                    <li key={index} className="service-item">
                      <span className="service-icon">✓</span>
                      {service}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="services-cta">
            <h2>Need Help with Your Business?</h2>
            <p>Contact us to discuss how we can assist with your specific requirements</p>
            <a href="/contact" className="btn btn-primary">Get in Touch</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
